import { z } from 'zod'

export const updateProfileSchema = z.object({
  name: z.string().min(1, 'Name must not be empty').optional(),
  avatar: z.string().optional(),
})

export type UpdateProfileDto = z.infer<typeof updateProfileSchema>
